<template>
    <div class="fullPage">
        <img src="../../assets/image/banner/banner3.jpg" alt class="fullWidth"/>
        <div class="main-center main-top">
            <!--拆单查询-->
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('spliteBill.voyageSpliteSearch')" class="searchComposite">
                    <div>
                        <div class="flex flex-space-around">
                            <!--船名/航次-->
                            <div class="inputName">
                                <el-col :span="7">
                                    <span class="inputName-title">
                                        {{$t('spliteBill.VVL')}}
                                    </span>
                                    <el-input v-model="search.vesselCode"
                                              :placeholder="$t('common.pleaseEnter')"
                                              clearable
                                              @input="formatUpper('search','vesselCode',search.vesselCode)"/>
                                </el-col>
                                <el-col :span="7">
                                    <el-input v-model="search.voyageNo" :placeholder="$t('common.pleaseEnter')"
                                              clearable
                                              @input="formatUpper('search','voyageNo',search.voyageNo)"/>
                                </el-col>
                                <el-col :span="5">
                                    <el-input v-model="search.voyageLeg" :placeholder="$t('common.pleaseEnter')"
                                              clearable
                                              @input="formatUpper('search','voyageLeg',search.voyageLeg)"/>
                                </el-col>

                                <!--船名航次VVL弹框-->
                                <el-popover ref="popover" placement="bottom" width="700" trigger="click"
                                            @hide="boatListShow=false">
                                    <div>
                                        <div class="flex flex-space-between">
                                            <!--船名查询条件-->
                                            <div class="inputName-left boatBox">
                                                <div class="inputName-title-left">
                                                        <span>
                                                            {{$t('booking.popover.vessel')}}
                                                        </span>
                                                </div>
                                                <el-input v-model="search.vesselCode"
                                                          :placeholder="$t('common.pleaseEnter')"
                                                          clearable
                                                          @input="formatUpper('search','vesselCode',search.vesselCode)"
                                                          @focus="showVesselList">
                                                    <img src="../../assets/image/icon/classification.svg"
                                                         slot="suffix"
                                                         @click="showVesselList">
                                                </el-input>
                                                <!--船名列表-->
                                                <div class="boatBox-list-box" v-show="boatListShow">
                                                    <div class="boatBox-top flex">
                                                        <div class="left">
                                                            {{$t('booking.popover.vesselCode')}}
                                                        </div>
                                                        <div class="right">
                                                            {{$t('booking.popover.vesselNameCn')}}
                                                        </div>
                                                    </div>
                                                    <ul>
                                                        <li v-for="(i,j) in boatList" class="flex"
                                                            :key="j"
                                                            @click="checkBoatData(i)">
                                                            <div class="left">{{i.vesselCode}}</div>
                                                            <div class="right">{{i.vesselNameCn}}</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <!--船中文名查询条件-->
                                            <div class="inputName-left">
                                                <div class="inputName-title-left">
                                                        <span>
                                                            {{$t('booking.popover.vesselNameCn')}}
                                                        </span>
                                                </div>
                                                <el-input v-model="search.vesselName"
                                                          :placeholder="$t('common.pleaseEnter')"
                                                          clearable
                                                          @input="formatUpper('search','vesselName',search.vesselName)"/>
                                            </div>
                                            <!--VVL查询按钮-->
                                            <el-button class="popoverInner" size="small" icon="el-icon-search"
                                                       @click="vvlSearch">
                                                {{findButton}}
                                            </el-button>
                                        </div>
                                        <div class="flex flex-space-between">
                                            <!--航次查询条件-->
                                            <div class="inputName-left">
                                                <div class="inputName-title-left">
                                                        <span>
                                                            {{$t('booking.popover.voyageNo')}}
                                                        </span>
                                                </div>
                                                <el-input v-model="search.voyageNo"
                                                          :placeholder="$t('common.pleaseEnter')"
                                                          clearable
                                                          @input="formatUpper('search','voyageNo',search.voyageNo)"/>
                                            </div>
                                            <!--航段查询条件-->
                                            <div class="inputName-left">
                                                <div class="inputName-title-left">
                                                        <span>
                                                            {{$t('booking.popover.voyageLeg')}}
                                                        </span>
                                                    <span style="visibility:hidden">占位</span>
                                                </div>
                                                <el-input v-model="search.voyageLeg"
                                                          :placeholder="$t('common.pleaseEnter')"
                                                          clearable
                                                          @input="formatUpper('search','voyageLeg',search.voyageLeg)"/>
                                            </div>
                                            <!--VVL关闭按钮-->
                                            <el-button size="small" class="popoverInner"
                                                       icon="el-icon-warning-outline"
                                                       @click="closePopoverView">
                                                {{closeButton}}
                                            </el-button>
                                        </div>
                                        <!--船名数据查询表格-->
                                        <el-table :data="popData" style="width:100%;margin-top:5px"
                                                  max-height="300" highlight-current-row
                                                  :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                                                  :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                                                  :empty-text="$t('common.noData')"
                                                  @row-dblclick="popRowDblclick"
                                                  @row-click="popRowClick">
                                            <!--序号-->
                                            <el-table-column min-width="60" type="index"
                                                             :label="$t('booking.popover.no')"
                                                             align="center"></el-table-column>
                                            <!--船舶代码-->
                                            <el-table-column min-width="110" prop="vesselCode"
                                                             :label="$t('booking.popover.vesselCode')"
                                                             align="center"></el-table-column>
                                            <!--船名-->
                                            <el-table-column min-width="190" prop="vesselName"
                                                             :label="$t('booking.popover.vessel')"
                                                             align="center"></el-table-column>
                                            <!--船中文名-->
                                            <el-table-column min-width="140" prop="vesselNameCn"
                                                             :label="$t('booking.popover.vesselNameCN')"
                                                             align="center"></el-table-column>
                                            <!--航次-->
                                            <el-table-column min-width="100" prop="voyageNo"
                                                             :label="$t('booking.popover.voyageNo')"
                                                             align="center"></el-table-column>
                                            <!--航段-->
                                            <el-table-column min-width="110" prop="voyageLeg"
                                                             :label="$t('booking.popover.voyageLeg')"
                                                             align="center"></el-table-column>
                                        </el-table>
                                        <div class="flex flex-space-between">
                                            <div class="topMargin flex1">
                                                {{getTotalDisplay}}
                                            </div>
                                            <!--VVL确认按钮-->
                                            <el-button class="topMargin" type="primary"
                                                       @click="popConfirm">
                                                {{confirmButton}}
                                            </el-button>
                                            <!--VVL pagination分页条-->
                                            <div class="pagination flex1">
                                                <el-pagination small layout="sizes,pager"
                                                               :page-size="popPageSize" :page-sizes="[5, 10]"
                                                               :total="popTotal"
                                                               :pager-count="popPageCount"
                                                               :current-page="popPageNum"
                                                               @size-change="popHandleSizeChange"
                                                               @current-change="popHandleCurrentChange"
                                                               max-height="600"></el-pagination>
                                            </div>
                                        </div>
                                    </div>
                                    <img slot="reference" style="cursor:pointer" class="voyageIcon"
                                         src="../../assets/image/voyage.png"/>
                                </el-popover>
                            </div>
                            <!--订舱号-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t("spliteBill.bkNo")}}
                                </span>
                                <el-input v-model="search.bkNo"
                                          :placeholder="$t('common.pleaseEnter')"
                                          @input="formatUpper('search','bkNo',search.bkNo)"/>
                            </div>
                            <!--提单号-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t("spliteBill.blNo")}}
                                </span>
                                <el-input v-model="search.blNo"
                                          :placeholder="$t('common.pleaseEnter')"
                                          @input="formatUpper('search','blNo',search.blNo)"/>
                            </div>
                            <!--查询按钮组-->
                            <div class="searchBtn">
                                <!--航次拆单查询按钮-->
                                <el-button type="primary" icon="el-icon-search"
                                           @click="voyageSpliteSearchAction">
                                    {{searchButton}}
                                </el-button>
                                <!--航次拆单查询条件重置按钮-->
                                <el-button icon="el-icon-refresh"
                                           @click="resetAction">
                                    {{resetButton}}
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <!--查询结果-->
            <div class="searchList">
                <div class="cardBox">
                    <el-row :gutter="20">
                        <!--舱单信息表格-->
                        <el-col style="width: 50%;">
                            <div class="cardTitle flex flex-align">
                                <img src="../../assets/image/icon/order2.svg" alt="">
                                <span>{{$t('spliteBill.billInfo')}}</span>
                            </div>
                            <div class="cardBody">
                                <el-table :data="tableBillInfo" ref="tableBillInfo" class="show_table"
                                          style="width:100%;margin-top:5px"
                                          height="250px" max-height="250" highlight-current-row
                                          :header-cell-style="{background:'#E9E9E9',height:'30px',padding:0}"
                                          :row-style="{height:'25px'}" :cell-style="{padding:'0px'}"
                                          :empty-text="$t('common.noData')"
                                          :row-class-name="rowClassName"
                                          @row-click="tableBillInfoRowClick">
                                    <!--序号-->
                                    <el-table-column min-width="50" show-overflow-tooltip type="index"
                                                     :label="this.$t('spliteBill.no')" align="center"/>
                                    <!--拆/并-->
                                    <el-table-column min-width="135" show-overflow-tooltip prop="spliteCombinDesc"
                                                     :label="$t('spliteBill.spliteCombinDesc')"
                                                     align="center">
                                        <template slot-scope="scope">
                                            <span>{{getspliteCombinDisplayValue(scope.row.spliteCombinDesc)}}</span>
                                        </template>
                                    </el-table-column>
                                    <!--提单号-->
                                    <el-table-column min-width="180" show-overflow-tooltip prop="blNo"
                                                     :label="$t('spliteBill.blNo')"
                                                     align="center"/>
                                    <!--订舱号-->
                                    <el-table-column min-width="180" show-overflow-tooltip prop="bkNo"
                                                     :label="$t('spliteBill.bkNo')"
                                                     align="center"/>
                                    <!--船名-->
                                    <el-table-column min-width="110" show-overflow-tooltip prop="vesselCode"
                                                     :label="$t('spliteBill.vesselCode')"
                                                     align="center"/>
                                    <!--船舶名称-->
                                    <el-table-column min-width="200" show-overflow-tooltip prop="vesselName"
                                                     :label="$t('spliteBill.vesselName')"
                                                     align="center"/>
                                    <!--航次-->
                                    <el-table-column min-width="120" show-overflow-tooltip prop="voyageNo"
                                                     :label="$t('spliteBill.voyageNo')"
                                                     align="center"/>
                                    <!--航段-->
                                    <el-table-column min-width="120" show-overflow-tooltip prop="voyageLeg"
                                                     :label="$t('spliteBill.voyageLeg')"
                                                     align="center"/>
                                    <!--装货港-->
                                    <el-table-column min-width="80" show-overflow-tooltip prop="pol"
                                                     :label="$t('spliteBill.pol')"
                                                     align="center"/>
                                    <!--卸货港-->
                                    <el-table-column min-width="80" show-overflow-tooltip prop="pod"
                                                     :label="$t('spliteBill.pod')"
                                                     align="center"/>
                                    <!--订舱代理-->
                                    <el-table-column min-width="400" show-overflow-tooltip prop="fwdDes"
                                                     :label="$t('spliteBill.fwdDes')"
                                                     align="center"/>
                                    <!--收货人-->
                                    <el-table-column min-width="220" show-overflow-tooltip prop="consigneeName"
                                                     :label="$t('spliteBill.consigneeName')"
                                                     align="center"/>
                                    <!--发货人-->
                                    <el-table-column min-width="220" show-overflow-tooltip prop="shipperName"
                                                     :label="$t('spliteBill.shipperName')"
                                                     align="center"/>
                                    <!--件数-->
                                    <el-table-column min-width="220" show-overflow-tooltip prop="cargoQuantity"
                                                     :label="$t('spliteBill.cargoQuantity')"
                                                     align="center"/>
                                    <!--毛重(KG)-->
                                    <el-table-column min-width="220" show-overflow-tooltip prop="cargoGrossWeight"
                                                     :label="$t('spliteBill.cargoGrossWeight')"
                                                     align="center"/>
                                    <!--尺寸-->
                                    <el-table-column min-width="220" show-overflow-tooltip prop="cargoSize"
                                                     :label="$t('spliteBill.cargoSize')"
                                                     align="center"/>
                                </el-table>
                                <div>
                                    <el-button @click="cancelSpliteAction" type="warning" size="mini"
                                               icon="el-icon-refresh-right" :disabled="!getCancelSpliteButtonEnabled">
                                        {{cancelSpliteButton}}
                                    </el-button>
                                </div>
                            </div>
                        </el-col>
                        <!--主单箱信息-->
                        <el-col style="width: 50%;">
                            <div class="cardTitle flex flex-align">
                                <img src="../../assets/image/icon/order12.svg" alt="">
                                <span>{{$t('spliteBill.masterPreContainerInfo')}}</span>
                            </div>
                            <div class="cardBody">
                                <el-table :data="tableMasterPreContainerInfo" ref="tableMasterPreContainerInfo"
                                          style="width:100%;margin-top:5px"
                                          height="250" max-height="300" highlight-current-row
                                          :header-cell-style="{background:'#E9E9E9',height:'30px',padding:0}"
                                          :row-style="{height:'25px'}" :cell-style="{padding:'0px'}"
                                          :empty-text="$t('common.noData')"
                                          :row-class-name="rowClassName"
                                          @row-click="tableMasterPreContainerInfoRowClick">
                                    <!--序号-->
                                    <el-table-column min-width="60" show-overflow-tooltip type="index"
                                                     :label="this.$t('spliteBill.no')" align="center"/>
                                    <!--箱型代码-->
                                    <el-table-column min-width="80" show-overflow-tooltip prop="containerType"
                                                     :label="$t('spliteBill.containerType')"
                                                     align="center"/>
                                    <!--数量-->
                                    <el-table-column min-width="80" show-overflow-tooltip prop="quantity"
                                                     :label="$t('spliteBill.quantity')"
                                                     align="center"/>
                                    <!--货类-->
                                    <el-table-column min-width="100" show-overflow-tooltip prop="cargoTypeCode"
                                                     :label="$t('spliteBill.cargoTypeCode')"
                                                     align="center">
                                        <template slot-scope="scope">
                                            <span>{{getCargoTypeName(scope.row.cargoTypeCode)}}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div>
                                    <el-button @click="copyToHBLAction" type="warning" size="mini"
                                               icon="el-icon-refresh-right" :disabled="!getcopyToHBLButtonEnabled">
                                        {{copyToHBLButton}}
                                    </el-button>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <!--分单信息表格-->
                        <el-col style="width: 50%;">
                            <div class="cardTitle flex flex-align">
                                <img src="../../assets/image/icon/order2.svg" alt="">
                                <span>{{$t('spliteBill.hblInfo')}}</span>
                            </div>
                            <div class="cardBody">
                                <el-table :data="tableHBLInfo" ref="tableHBLInfo" class="show_table"
                                          style="width:100%;margin-top:5px"
                                          height="250" max-height="250" highlight-current-row
                                          :header-cell-style="{background:'#E9E9E9',height:'30px',padding:0}"
                                          :row-style="{height:'25px'}" :cell-style="{padding:'0px'}"
                                          :empty-text="$t('common.noData')"
                                          :row-class-name="rowClassName"
                                          @row-click="tableHBLRowClick"
                                          @cell-dblclick="editData">
                                    <!--序号-->
                                    <el-table-column min-width="50" show-overflow-tooltip type="index"
                                                     :label="this.$t('booking.no')" align="center"/>
                                    <!--提单号-->
                                    <el-table-column min-width="220" show-overflow-tooltip prop="blNo"
                                                     :label="$t('spliteBill.blNo')"
                                                     align="center">
                                        <template slot-scope="scope">
                                            <el-input
                                                    v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                                    :ref="scope.column.property"
                                                    v-model="scope.row.blNo" size="small"
                                                    @input="formatUpper('tableHBLInfo','blNo',scope.row.blNo,scope.row.index)"
                                                    @blur="alterData(scope.row,scope.column)">
                                                <el-button style="padding-right:10px" slot="suffix"
                                                           icon="el-icon-check" type="text" size="mini"
                                                           @click="alterData(scope.row,scope.column)"/>
                                            </el-input>
                                            <span v-else>{{ scope.row.blNo }}</span>
                                        </template>
                                    </el-table-column>
                                    <!--订舱号-->
                                    <el-table-column min-width="220" show-overflow-tooltip prop="bkNo"
                                                     :label="$t('spliteBill.bkNo')"
                                                     align="center">
                                        <template slot-scope="scope">
                                            <el-input
                                                    v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                                    :ref="scope.column.property"
                                                    v-model="scope.row.bkNo" size="small"
                                                    @input="formatUpper('tableHBLInfo','bkNo',scope.row.bkNo,scope.row.index)"
                                                    @blur="alterData(scope.row,scope.column)">
                                                <el-button style="padding-right:10px" slot="suffix"
                                                           icon="el-icon-check" type="text" size="mini"
                                                           @click="alterData(scope.row,scope.column)"/>
                                            </el-input>
                                            <span v-else>{{ scope.row.bkNo }}</span>
                                        </template>
                                    </el-table-column>
                                    <!--收货人名称-->
                                    <el-table-column min-width="400" show-overflow-tooltip prop="consigneeName"
                                                     :label="$t('spliteBill.consigneeName')"
                                                     align="center">
                                        <!--<template slot-scope="scope">
                                            <el-input
                                                    v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                                    :ref="scope.column.property"
                                                    v-model="scope.row.consigneeName" type="textarea" :rows="6"
                                                    maxlength="245" show-word-limit size="small"
                                                    @input="validateSingleLineCharLength('tableHBLInfo','consigneeName',scope.row.consigneeName,7,35,scope.row.index)"
                                                    @keydown.enter.native="((val) => {validateKeyDown(2, scope.row.consigneeName, 7,35,scope.row.index)})"
                                                    @blur="alterData(scope.row,scope.column)">
                                                <el-button style="padding-right:10px" slot="suffix"
                                                           icon="el-icon-check" type="text" size="mini"
                                                           @click="alterData(scope.row,scope.column)"/>
                                            </el-input>
                                            <span v-else>{{ scope.row.consigneeName }}</span>
                                        </template>-->
                                    </el-table-column>
                                    <!--发货人名称-->
                                    <el-table-column min-width="400" show-overflow-tooltip prop="shipperName"
                                                     :label="$t('spliteBill.shipperName')"
                                                     align="center">
                                        <!--<template slot-scope="scope">
                                            <el-input
                                                    v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                                    :ref="scope.column.property"
                                                    v-model="scope.row.shipperName" type="textarea" :rows="6"
                                                    maxlength="245" show-word-limit size="small"
                                                    @input="validateSingleLineCharLength('tableHBLInfo','shipperName',scope.row.shipperName,7,35,scope.row.index)"
                                                    @keydown.enter.native="((val) => {validateKeyDown(2, scope.row.shipperName, 7,35)})"
                                                    @blur="alterData(scope.row,scope.column)">
                                                <el-button style="padding-right:10px" slot="suffix"
                                                           icon="el-icon-check" type="text" size="mini"
                                                           @click="alterData(scope.row,scope.column)"/>
                                            </el-input>
                                            <span v-else>{{ scope.row.shipperName }}</span>
                                        </template>-->
                                    </el-table-column>
                                    <!--品名代码-->
                                    <el-table-column min-width="150" show-overflow-tooltip prop="cargoCommodityCode"
                                                     :label="$t('spliteBill.cargoCommodityCode')"
                                                     align="center">
                                        <template slot-scope="scope">
                                            <el-input
                                                    v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                                    :ref="scope.column.property"
                                                    v-model="scope.row.cargoCommodityCode" size="small"
                                                    @blur="alterData(scope.row,scope.column)">
                                                <el-button style="padding-right:10px" slot="suffix"
                                                           icon="el-icon-check" type="text" size="mini"
                                                           @input="formatUpper('tableHBLInfo','cargoCommodityCode',scope.row.cargoCommodityCode,scope.row.index)"
                                                           @click="alterData(scope.row,scope.column)"/>
                                            </el-input>
                                            <span v-else>{{ scope.row.cargoCommodityCode }}</span>
                                        </template>
                                    </el-table-column>
                                    <!--品名名称-->
                                    <el-table-column min-width="200" show-overflow-tooltip prop="cargoCommodityName"
                                                     :label="$t('spliteBill.cargoCommodityName')"
                                                     align="center">
                                        <template slot-scope="scope">
                                            <el-input
                                                    v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                                    :ref="scope.column.property"
                                                    v-model="scope.row.cargoCommodityName" size="small"
                                                    @input="formatUpper('tableHBLInfo','cargoCommodityName',scope.row.cargoCommodityName,scope.row.index)"
                                                    @blur="alterData(scope.row,scope.column)">
                                                <el-button style="padding-right:10px" slot="suffix"
                                                           icon="el-icon-check" type="text" size="mini"
                                                           @click="alterData(scope.row,scope.column)"/>
                                            </el-input>
                                            <span v-else>{{ scope.row.cargoCommodityName }}</span>
                                        </template>
                                    </el-table-column>
                                    <!--唛头-->
                                    <el-table-column min-width="220" show-overflow-tooltip prop="cargoShippingMark"
                                                     :label="$t('spliteBill.cargoShippingMark')"
                                                     align="center">
                                        <template slot-scope="scope">
                                            <el-input
                                                    v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                                    maxlength="3150" show-word-limit
                                                    :ref="scope.column.property"  type="textarea" :rows="6"
                                                    v-model="scope.row.cargoShippingMark" size="small"
                                                    @blur="alterData(scope.row,scope.column)"
                                                    @input="validateSingleLineCharLength('tableHBLInfo','cargoShippingMark',scope.row.cargoShippingMark,90,35,scope.row.index)"
                                                    @keydown.enter.native="((val) => {validateKeyDown(6, scope.row.cargoShippingMark, 90,35,scope.row.index)})">
                                                <el-button style="padding-right:10px" slot="suffix"
                                                           icon="el-icon-check" type="text" size="mini"
                                                           @click="alterData(scope.row,scope.column)"/>
                                            </el-input>
                                            <span v-else>{{ scope.row.cargoShippingMark }}</span>
                                        </template>
                                    </el-table-column>
                                    <!--制单件数-->
                                    <el-table-column min-width="130" show-overflow-tooltip prop="cargoQuantity"
                                                     :label="$t('spliteBill.cargoQuantity')"
                                                     align="center">
                                        <template slot-scope="scope">
                                            <el-input
                                                    v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                                    :ref="scope.column.property"
                                                    v-model="scope.row.cargoQuantity" size="small"
                                                    oninput="value=value.replace(/[^0-9]/g,'')"
                                                    @blur="alterData(scope.row,scope.column)">
                                                <el-button style="padding-right:10px" slot="suffix"
                                                           icon="el-icon-check" type="text" size="mini"
                                                           @click="alterData(scope.row,scope.column)"/>
                                            </el-input>
                                            <span v-else>{{ scope.row.cargoQuantity }}</span>
                                        </template>
                                    </el-table-column>
                                    <!--制单毛重(KG)-->
                                    <el-table-column min-width="150" show-overflow-tooltip prop="cargoGrossWeight"
                                                     :label="$t('spliteBill.cargoGrossWeight')"
                                                     align="center">
                                        <template slot-scope="scope">
                                            <el-input
                                                    v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                                    :ref="scope.column.property"
                                                    v-model="scope.row.cargoGrossWeight" size="small"
                                                    @input="formatNumber('tableHBLInfo','cargoGrossWeight',scope.row.cargoGrossWeight,3,scope.row.index)"
                                                    @blur="alterData(scope.row,scope.column)">
                                                <el-button style="padding-right:10px" slot="suffix"
                                                           icon="el-icon-check" type="text" size="mini"
                                                           @click="alterData(scope.row,scope.column)"/>
                                            </el-input>
                                            <span v-else>{{ scope.row.cargoGrossWeight }}</span>
                                        </template>
                                    </el-table-column>
                                    <!--制单尺寸-->
                                    <el-table-column min-width="150" show-overflow-tooltip prop="cargoSize"
                                                     :label="$t('spliteBill.cargoSize')"
                                                     align="center">
                                        <template slot-scope="scope">
                                            <el-input
                                                    v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                                    :ref="scope.column.property"
                                                    v-model="scope.row.cargoSize" size="small"
                                                    @input="formatNumber('tableHBLInfo','cargoSize',scope.row.cargoSize,3,scope.row.index)"
                                                    @blur="alterData(scope.row,scope.column)">
                                                <el-button style="padding-right:10px" slot="suffix"
                                                           icon="el-icon-check" type="text" size="mini"
                                                           @click="alterData(scope.row,scope.column)"/>
                                            </el-input>
                                            <span v-else>{{ scope.row.cargoSize }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div>
                                    <el-button @click="queryHBLByVoyageAction" type="primary" size="mini"
                                               icon="el-icon-search" :disabled="!getHBLQueryButtonEnabled">
                                        {{queryHBLByVoyageButton}}
                                    </el-button>
                                    <el-button @click="newHBLAction" type="success" size="mini"
                                               icon="el-icon-circle-plus" :disabled="!getNewHBLButtonEnabled">
                                        {{newHBLButton}}
                                    </el-button>
                                    <el-button @click="saveHBLAction" type="warning" size="mini"
                                               icon="el-icon-success" :disabled="!getsaveHBLButtonEnabled">
                                        {{saveHBLButton}}
                                    </el-button>
                                    <el-button @click="deleteHBLAction" type="info" size="mini"
                                               icon="el-icon-delete-solid" :disabled="!getdeleteHBLButtonEnabled">
                                        {{deleteHBLButton}}
                                    </el-button>
                                </div>
                            </div>
                        </el-col>
                        <!--分单订舱预配箱信息-->
                        <el-col style="width: 50%;">
                            <div class="cardTitle flex flex-align">
                                <img src="../../assets/image/icon/order12.svg" alt="">
                                <span>{{$t('spliteBill.hBLPreContainerInfo')}}</span>
                            </div>
                            <div class="cardBody">
                                <el-table :data="tableHBLPreContainerInfo" ref="tableHBLPreContainerInfo"
                                          style="width:100%;margin-top:5px"
                                          height="250" max-height="300" highlight-current-row
                                          :header-cell-style="{background:'#E9E9E9',height:'30px',padding:0}"
                                          :row-style="{height:'25px'}" :cell-style="{padding:'0px'}"
                                          :empty-text="$t('common.noData')"
                                          :row-class-name="rowClassName"
                                          @row-click="tableHBLPreContainerInfoRowClick">
                                    <!--序号-->
                                    <el-table-column min-width="60" show-overflow-tooltip type="index"
                                                     :label="this.$t('spliteBill.no')" align="center"/>
                                    <!--箱型代码-->
                                    <el-table-column min-width="80" show-overflow-tooltip prop="containerType"
                                                     :label="$t('spliteBill.containerType')"
                                                     align="center"/>
                                    <!--数量-->
                                    <el-table-column min-width="50" show-overflow-tooltip prop="quantity" :label="$t('spliteBill.quantity')"
                                                     align="center">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.quantity" oninput="value=value.replace(/[^0-9]/g,'')" size="small" style="text-align: center"/>
                                        </template>
                                    </el-table-column>
                                    <!--货类-->
                                    <el-table-column min-width="100" show-overflow-tooltip prop="cargoTypeCode"
                                                     :label="$t('spliteBill.cargoTypeCode')"
                                                     align="center">
                                        <template slot-scope="scope">
                                            <span>{{getCargoTypeName(scope.row.cargoTypeCode)}}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="flex flex-space-between">
                                    <el-button @click="DeleteHBLPreContainerDeleteAction" type="primary" size="mini"
                                               icon="el-icon-search" :disabled="!getDeleteHBLPreContainerButtonEnabled">
                                        {{deleteButton}}
                                    </el-button>
<!--                                    <el-col :span="14">-->
<!--                                        <el-input-->
<!--                                                placeholder="0" size="mini"-->
<!--                                                v-model="partTotal.quantity"-->
<!--                                                :disabled="true">-->
<!--                                            <template slot="prepend">{{$t("spliteBill.containerTypeAndQuantity")}}</template>-->
<!--                                        </el-input>-->
<!--                                    </el-col>-->
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>

        <!--分单查询弹出框-->
        <el-dialog
                :visible.sync="HBLInfoDialogVisible"
                width="40%" top="10%">
            <div slot="title" class="flex flex-align">
                <img src="../../assets/image/icon/order-ico5.svg" alt="">
                {{$t('spliteBill.hBLSearch')}}
            </div>
            <div>
                <div class="flex flex-space-between">
                    <!--提单号查询条件-->
                    <div class="inputName-left boatBox">
                        <div class="inputName-title-left">
                            <span>{{$t('spliteBill.blNo')}}</span>
                        </div>
                        <el-input v-model="HBLSearch.blNo"
                                  :placeholder="$t('common.pleaseEnter')"
                                  clearable
                                  @input="formatUpper('HBLSearch','blNo',search.blNo)">
                        </el-input>
                    </div>
                    <div class="inputName-left boatBox">
                        <!--分单查询按钮-->
                        <el-button class="popoverInner" size="small" icon="el-icon-search"
                                   @click="popHBLSearchClick">
                            {{findButton}}
                        </el-button>
                        <!--重置按钮-->
                        <el-button class="popoverInner" size="small" icon="el-icon-search"
                                   @click="popHBLResetClick">
                            {{resetButton}}
                        </el-button>
                    </div>
                </div>
                <!--分单数据表格-->
                <el-table :data="popTableSearchHBLInfo" style="margin-top:5px"
                          height="250px" max-height="250" highlight-current-row
                          :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                          :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                          :empty-text="$t('common.noData')" class="pop_show_table"
                          @selection-change="popHBLTableSelectionChange">
                    <!--多选-->
                    <el-table-column type="selection" width="42"/>
                    <!--序号-->
                    <el-table-column min-width="50" type="index"
                                     :label="$t('spliteBill.no')"
                                     align="center"></el-table-column>
                    <!--提单号-->
                    <el-table-column min-width="180" show-overflow-tooltip prop="blNo"
                                     :label="$t('spliteBill.blNo')"
                                     align="center"></el-table-column>
                    <!--订舱号-->
                    <el-table-column min-width="180" show-overflow-tooltip prop="bkNo"
                                     :label="$t('spliteBill.bkNo')"
                                     align="center"></el-table-column>
                    <!--装货港-->
                    <el-table-column min-width="80" show-overflow-tooltip prop="pol"
                                     :label="$t('spliteBill.pol')"
                                     align="center"></el-table-column>
                    <!--卸货港-->
                    <el-table-column min-width="80" show-overflow-tooltip prop="pod"
                                     :label="$t('spliteBill.pod')"
                                     align="center"></el-table-column>
                    <!--收货人名称-->
                    <el-table-column min-width="400" show-overflow-tooltip prop="consigneeName"
                                     :label="$t('spliteBill.consigneeName')"
                                     align="center"></el-table-column>
                    <!--发货人名称-->
                    <el-table-column min-width="400" show-overflow-tooltip prop="shipperName"
                                     :label="$t('spliteBill.shipperName')"
                                     align="center"></el-table-column>
                    <!--通知人名称-->
                    <el-table-column min-width="400" show-overflow-tooltip prop="notify1Name"
                                     :label="$t('spliteBill.notify1Name')"
                                     align="center"></el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="popAddHBLClick">{{confirmButton}}</el-button>
                    <el-button @click="popCancelClick">{{cancelButton}}</el-button>
                  </span>
            </div>
        </el-dialog>

        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "booking",
        computed: {
            voyageSpliteSearch() {//航次拆单查询按钮
                return this.$t("common.searchButton");
            },
            searchButton() {//查询按钮
                return this.$t("common.searchButton");
            },
            resetButton() {//重置按钮
                return this.$t("common.resetButton");
            },
            cancelSpliteButton() {//取消拆单按钮
                return this.$t("spliteBill.cancelSpliteButton");
            },
            findButton() {//搜索按钮
                return this.$t("common.findButton");
            },
            getTotalDisplay() {
                return this.$t("common.total").replace("?", this.popTotal);
            },
            closeButton() {//关闭按钮
                return this.$t("common.closeButton");
            },
            confirmButton() {//确认按钮
                return this.$t("common.confirmButton");
            },
            cancelButton() {//取消按钮
                return this.$t("common.cancelButton");
            },
            queryHBLByVoyageButton() {//分单查询
                return this.$t("spliteBill.queryHBLByVoyageButton");
            },
            newHBLButton() {//新增分单
                return this.$t("spliteBill.newHBLButton");
            },
            saveHBLButton() {//保存分单
                return this.$t("spliteBill.saveHBLButton");
            },
            deleteHBLButton() {//删除分单
                return this.$t("spliteBill.deleteHBLButton");
            },
            deleteButton() {//删除按钮
                return this.$t("common.deleteButton");
            },
            copyToHBLButton() {//复制到分单
                return this.$t("spliteBill.copyToHBLButton");
            },
            //复制到分单按钮权限控制
            getcopyToHBLButtonEnabled() {
                if(this.tableBillInfo.length > 0 && !this.validateIsSplitBill()){
                    if(this.tableMasterPreContainerInfo.length <= 0){
                        return false;
                    }
                    if(this.tableHBLInfo.length > 0
                        && this.tableHBLInfoSelection.length  > 0){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    return false;
                }
            },
            //分单查询按钮权限控制
            getHBLQueryButtonEnabled() {
                return this.tableBillInfo.length > 0
                    && this.tableBillInfoSelection.length > 0
                    && !this.validateIsSplitBill()
                    && !this.validateHasContainers();
            },
            //新增分单按钮权限控制
            getNewHBLButtonEnabled() {
                return this.tableBillInfo.length > 0
                    && this.tableBillInfoSelection.length > 0
                    && !this.validateIsSplitBill()
                    && !this.validateHasContainers();
            },
            //取消拆单按钮权限控制
            getCancelSpliteButtonEnabled() {
                return this.tableBillInfo.length > 0
                    && this.tableBillInfoSelection.length > 0
                    && this.validateIsSplitBill()
                    && !this.validateHasContainers();
            },
            //分单保存按钮权限控制
            getsaveHBLButtonEnabled() {
                if (this.tableBillInfo.length > 0) {
                    if (this.tableHBLInfo.length > 0 && this.tableHBLInfoSelection.length > 0) {
                        return !this.validateIsSplitBill();
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            //分单删除按钮权限控制
            getdeleteHBLButtonEnabled() {
                if (this.tableBillInfo.length > 0) {
                    if (this.tableHBLInfo.length > 0 && this.tableHBLInfoSelection.length > 0) {
                        let selectedHBL = this.tableHBLInfoSelection[0];
                        if (selectedHBL.rowStatus == 4) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            //分单下货纸箱信息删除按钮权限控制
            getDeleteHBLPreContainerButtonEnabled() {
                if (this.tableBillInfo.length > 0) {
                    if (this.tableHBLPreContainerInfo.length > 0 && this.tableHBLPreContainerInfoSelection.length > 0) {
                        let selected = this.tableHBLPreContainerInfoSelection[0];
                        if (selected.rowStatus == 4) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            }
        },
        components: {},
        data() {
            return {
                isClick: false,             //控制查询按钮是否重复点击
                boatListShow: false,
                HBLInfoDialogVisible: false,
                cargoTypeOptions: [],
                containerTypeOptions: [],
                //拆并单类型
                spliteCombinDescOptions: [
                    {codeValue: 0, displayValueCn: "未拆并单", displayValue: "No Splite Combin Bill"},
                    {codeValue: 1, displayValueCn: "拆单主单", displayValue: "Splite MBL"},
                    {codeValue: 2, displayValueCn: "拆单分单", displayValue: "Splite HBL"},
                    {codeValue: 3, displayValueCn: "并单主单", displayValue: "Combin MBL"},
                    {codeValue: 4, displayValueCn: "并单分单", displayValue: "Combin HBL"}
                ],
                //拆单查询参数
                search: {
                    vesselCode: "",         //船舶代码
                    voyageNo: "",           //航次
                    voyageLeg: "",          //航段
                    bkNo: "",               //订舱号
                    blNo: "",               //提单号
                    shipperName: "",        //发货人
                    consigneeName: "",      //收货人
                    vesselName: ""          //船舶名称
                },
                //拆单分单箱信息件重尺合计数据
                partTotal: {
                    quantity: 0,
                    grossWeight: 0,
                    cargoSize: 0
                },
                //分单查询参数
                HBLSearch: {
                    vesselCode: "",         //船舶代码
                    voyageNo: "",           //航次
                    voyageLeg: "",          //航段
                    pod: "",                //卸货港
                    blNo: ""                //提单号
                },
                //表格数据
                tableBillInfo: [],          //舱单信息
                tableMasterPreContainerInfo: [],//主单下货纸箱信息
                tableHBLInfo: [],           // 分单信息
                tableHBLPreContainerInfo: [],//分单下货纸箱信息
                addHBLBillInfoList: [],     //新增分单信息
                popData: [],
                popPageCount: 5,
                popPageNum: 1,
                popPageSize: 5,
                popTotal: 0,
                popTableSearchHBLInfo: [],   //分单查询弹框表格数据
                boatList: [],
                //表格选中当前行数据
                popVVLTableSelection: [],   //vvl弹框中鼠标点击选中的值
                popHBLTableSelection: [],   //分单查询弹框中选中的分单
                tableBillInfoSelection: [], //主单信息表格中选中的当前行
                tableHBLInfoSelection: [],  //分单信息表格中选中的当前行
                tableMasterPreContainerInfoSelection: [],  //主单下货纸箱信息表格中选中的当前行
                tableHBLPreContainerInfoSelection: [],  //分单下货纸箱信息表格中选中的当前行
                //表格批量勾选数据
                popTableHBLInfoChecked: [], //分单查询弹框中批量勾选的分单记录
                tableHBLInfoChecked: [],    //存放分单表格中批量勾选的分单记录
                randomKey: Math.random(),
                randomKey2: Math.random(),
                count: 1
            };
        },
        methods: {
            /**
             * 航次拆单查询
             */
            voyageSpliteSearchAction() {
                if (this.isClick) {
                    return;
                }
                this.isClick = true;

                // 查询条件非空校验
                if (this.search.vesselCode === ""
                    || this.search.voyageNo === ""
                    || this.search.voyageLeg === "") {
                    this.showMessage(false, this.$t("message.pleaseEnterqueryConditions"), "warning");
                    this.isClick = false;
                    return;
                }

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),             // 加载动画的文字
                    spinner: 'el-icon-loading',                     // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                    target: document.querySelector(".searchList")   // 设置加载动画区域
                });
                let that = this;
                //调用后端拆单查询API
                this.axios({
                    method: 'post',
                    url: '/api/spliteCombine/getSpliteBillList',
                    data: {
                        vesselCode: this.search.vesselCode,
                        voyageNo: this.search.voyageNo,
                        voyageLeg: this.search.voyageLeg,
                        bkNo: this.search.bkNo,
                        blNo: this.search.blNo
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    that.loadingtuo.close();
                    if (response.data.backCode === "200") {
                        this.clearSelectionAction(0, true);
                        this.clearSelectionAction(1, true);
                        //赋值主单数据
                        let listMBLInfo = JSON.parse(response.data.object);
                        this.tableBillInfo = listMBLInfo;
                        //默认选中首行主单
                        if (this.tableBillInfo.length > 0) {
                            this.setTableCurrentRow(0, 0);
                        }
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    this.isClick = false;
                }).catch(error => {
                    that.loadingtuo.close();
                    //请求失败,查询按钮设置为未点击状态,允许再次请求
                    this.isClick = false;
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 清空页面表格当前选中行数据
             * type: 0-清空主单选中  1：清空分单选中
             * isClearTable: true-清空表格全部数据   false-保留表格数据
             */
            clearSelectionAction(type, isClearTable) {
                if (type === 0) {
                    // 清空主单表格当前选中行
                    this.tableBillInfoSelection = [];
                    // 清空主单下货纸箱信息表格
                    this.tableMasterPreContainerInfo = [];
                    this.tableMasterPreContainerInfoSelection = [];
                    if (isClearTable) {
                        this.tableBillInfo = [];
                    }
                }
                if (type === 1) {
                    // 清空分单表格当前选中行
                    this.tableHBLInfoSelection = [];
                    // 清空分单下货纸箱信息表格
                    this.tableHBLPreContainerInfo = [];
                    // 清空新增分单记录集合
                    this.addHBLBillInfoList = [];
                    if (isClearTable) {
                        this.tableHBLInfo = [];
                    }
                }
            },
            resetAction() {//重置按钮点击
                this.search.vesselCode = "";
                this.search.voyageNo = "";
                this.search.voyageLeg = "";
                this.search.bkNo = "";
                this.search.blNo = "";
                this.search.vesselName = "";
            },


            //保留2位小数
            toDecimal2(x) {
                var f = parseFloat(x);
                if (isNaN(f)) {
                    return false;
                }
                var ff = Math.round(x * 100) / 100;
                var s = ff.toString();
                var rs = s.indexOf('.');
                if (rs < 0) {
                    rs = s.length;
                    s += '.';
                }
                while (s.length <= rs + 2) {
                    s += '0';
                }
                return s;
            },
            /**
             * 分单信息表格编辑事件
             */
            editData(row, column) {
                let isEditable = false;
                if (this.tableBillInfo.length > 0) {
                    if (this.tableHBLInfo.length > 0 && this.tableHBLInfoSelection.length > 0) {
                        let selectedHBL = this.tableHBLInfoSelection[0];
                        if (selectedHBL.rowStatus == 4) {
                            isEditable = !this.validateIsSplitBill();
                        } else {
                            isEditable = false;
                        }
                    } else {
                        isEditable = false;
                    }
                } else {
                    isEditable = false;
                }
                row[column.property + row.index + "isShow"] = isEditable && true;
                //refreshTable是table数据改动时，刷新table的
                this.refreshTable();
                this.$nextTick(() => {
                    this.$refs[column.property] && this.$refs[column.property].focus()
                })
            },
            alterData(row, column) {
                row[column.property + row.index + "isShow"] = false;
                this.refreshTable()
            },
            refreshTable() {
                this.randomKey = Math.random()
            },
            /**
             * 获取分单箱信息中件重尺合计
             */
            calculatePartTotal() {
                if (this.tableHBLPreContainerInfo != null && this.tableHBLPreContainerInfo.length > 0) {
                    let quantity = 0;
                    let grossWeight = 0;
                    let cargoSize = 0;
                    this.tableHBLPreContainerInfo.forEach((container) => {
                        //统计件数
                        if (container.quantity !== "") {
                            quantity = quantity + container.quantity
                        }
                        //统计毛重
                        if (container.weight !== "") {
                            grossWeight = grossWeight + container.weight
                        }
                        //统计尺寸
                        if (container.cntrSize !== "") {
                            cargoSize = cargoSize + container.cntrSize
                        }
                    });
                    this.partTotal.quantity = this.toDecimal2(quantity);
                    this.partTotal.grossWeight = this.toDecimal2(grossWeight);
                    this.partTotal.cargoSize = this.toDecimal2(cargoSize);
                } else {
                    this.partTotal.quantity = this.toDecimal2(0);
                    this.partTotal.grossWeight = this.toDecimal2(0);
                    this.partTotal.cargoSize = this.toDecimal2(0);
                }
            },
            /**
             * 校验换行是否允许，超过最大行数-1时，不允许换行
             * val：默认参数
             * content：输入内容
             * row：最大行数
             * length: 单行最大字符个数
             */
            validateKeyDown(val, content, row, length) {
                let rowArray = [];
                if (content != "") {
                    rowArray = content.split("\n");//获取单行数据
                }

                let event = window.event || arguments[0];
                // console.log(event,event.keyCode);
                if (event.key == 'Enter' || event.code == 'Enter' || event.keyCode == 13) {//回车键
                    //判断当前行数是否已达到最大行数
                    if (rowArray.length > 0) {
                        if (rowArray.length > row - 1) {//超过最大行数，则不允许换行
                            this.$message({
                                showClose: true,
                                message: val === 5 || val === 6 ?
                                    this.$t('message.charLengthLimitMsg2',
                                        {
                                            length: length,
                                            row: row
                                        }) :
                                    this.$t('message.charLengthLimitMsg',
                                        {
                                            length: length,
                                            row: row
                                        }),
                                type: 'error'
                            });
                            event.returnValue = false;
                            return false;
                        }
                    }
                }
            },

            /**
             * 分单查询表格批量勾选事件
             */
            popHBLTableSelectionChange(array) {
                this.popTableHBLInfoChecked = array;
            },
            rowClassName({row, rowIndex}) {
                //把每一行的索引放进row
                row.index = rowIndex;
            },
            /**
             * 主单信息行记录点击事件
             */
            tableBillInfoRowClick(row) {
                this.setTableCurrentRow(0, row.index);
            },
            /**
             * 主单信息行记录点击事件
             */
            tableMasterPreContainerInfoRowClick(row) {
                this.setTableCurrentRow(1, row.index);
            },
            /**
             * 分单信息行记录点击事件
             */
            tableHBLRowClick(row) {
                this.setTableCurrentRow(2, row.index);
            },
            /**
             * 分单下货纸信息行记录点击事件
             */
            tableHBLPreContainerInfoRowClick(row) {
                this.setTableCurrentRow(3, row.index);
            },
            /**
             * 选中提单信息行带出下货纸箱信息
             * type: 0-设置主单表格当前选中行  2-设置分单表格当前选中行
             * index: 设置要选中的行索引
             */
            setTableCurrentRow(type, index) {
                // 清空选中行记录数组及下货纸箱信息
                if (type === 0) {
                    // 清空主单下货纸箱信息
                    this.tableMasterPreContainerInfo = [];
                    //设置主单信息表格当前选中行
                    this.$refs.tableBillInfo.setCurrentRow(this.tableBillInfo[index], true);
                    // 选中行添加进主单选中记录数组中
                    this.tableBillInfoSelection = [this.tableBillInfo[index]];
                    // 加载选中主单下货纸箱信息
                    if (this.tableBillInfoSelection.length > 0) {
                        if (this.tableBillInfoSelection[0].bkPreContainers != null && this.tableBillInfoSelection[0].bkPreContainers.length > 0) {
                            this.tableMasterPreContainerInfo = this.tableBillInfoSelection[0].bkPreContainers;
                        }
                        // 若选中提单为拆单主单，则继续加载分单信息
                        this.loadHBLInfoInfo(this.tableBillInfoSelection[0]);
                    }
                } else if (type === 1){
                    // 清空主单下货纸箱信息选中行记录数组
                    this.tableMasterPreContainerInfoSelection = [];
                    //设置主单信息表格当前选中行
                    this.$refs.tableMasterPreContainerInfo.setCurrentRow(this.tableMasterPreContainerInfo[index], true);
                    // 选中行添加进主单选中记录数组中
                    this.tableMasterPreContainerInfoSelection = [this.tableMasterPreContainerInfo[index]];
                }else if (type === 2) {
                    // 清空分单下货纸箱信息及选中信息
                    this.tableHBLPreContainerInfo = [];
                    this.tableHBLPreContainerInfoSelection = [];
                    //设置分单信息表格当前选中行
                    this.$refs.tableHBLInfo.setCurrentRow(this.tableHBLInfo[index], true);
                    this.tableHBLInfoSelection = [this.tableHBLInfo[index]];
                    // 加载选中分单箱信息
                    if (this.tableHBLInfoSelection.length > 0) {
                        if (this.tableHBLInfoSelection[0].bkPreContainers != null && this.tableHBLInfoSelection[0].bkPreContainers.length > 0) {
                            this.tableHBLPreContainerInfo = this.tableHBLInfoSelection[0].bkPreContainers;
                            this.setTableCurrentRow(3,0)
                        }
                    }
                }else if (type === 3){
                    // 清空分单下货纸箱信息选中行记录数组
                    this.tableHBLPreContainerInfoSelection = [];
                    //设置分单信息表格当前选中行
                    this.$refs.tableHBLPreContainerInfo.setCurrentRow(this.tableHBLPreContainerInfo[index], true);
                    // 选中行添加进主单选中记录数组中
                    this.tableHBLPreContainerInfoSelection = [this.tableHBLPreContainerInfo[index]];
                }
            },
            /**
             * 加载分单信息
             */
            loadHBLInfoInfo(MBLInfo) {
                if (MBLInfo == null || MBLInfo.bookingHeadId == "") {
                    return;
                }
                if (MBLInfo.spliteCombinType != null && MBLInfo.spliteCombinType == 0
                    && MBLInfo.mainDetailType != null && MBLInfo.mainDetailType == 0) {
                    //调用后端并单分单查询API
                    this.axios({
                        method: 'post',
                        url: '/api/spliteCombine/getSpliteHBLBillList',
                        data: {
                            bookingHeadId: MBLInfo.bookingHeadId
                        },
                        headers: {
                            'Accept-language': localStorage.getItem("locale")
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            let listHBLInfo = JSON.parse(response.data.object);
                            this.tableHBLInfo = listHBLInfo;
                            //默认选中首行分单
                            if (this.tableHBLInfo.length > 0) {
                                this.setTableCurrentRow(2, 0);
                            }
                            this.calculatePartTotal();
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                        }
                    }).catch(error => {
                        //请求失败,查询按钮设置为未点击状态,允许再次请求
                        if (error.data) {
                            this.tableHBLInfo = [];
                            this.tableHBLPreContainerInfo = [];
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                } else {
                    //清空分单信息和分单箱信息
                    this.tableHBLInfo = [];
                    this.tableHBLInfoSelection = [];
                    this.tableHBLPreContainerInfo = [];
                }
            },
            /**
             * 复制到分单
             */
            copyToHBLAction() {
                if(this.tableBillInfoSelection.length > 0
                    && this.tableHBLInfoSelection.length > 0) {//选中分单
                    if (this.tableMasterPreContainerInfo.length > 0) {//主单有下货纸信息
                        if(this.tableMasterPreContainerInfoSelection.length > 0){
                            // 获取选中分单
                            let currentHBLInfo = this.tableHBLInfoSelection[0];
                            //调用后端并单分单查询API
                            this.axios({
                                method: 'post',
                                url: '/api/spliteCombine/getCopyOfPreContainerInfo',
                                data: {
                                    bookingHeadMBLId: this.tableBillInfoSelection[0].bookingHeadId,
                                    vwSpliteCombinHBL: JSON.stringify(currentHBLInfo)
                                },
                                headers: {
                                    'Accept-language': localStorage.getItem("locale"),
                                    'Content-type': "application/json;charset=utf-8"
                                }
                            }).then(response => {
                                this.responseCode = response.data.backMessage;
                                if (response.data.backCode === "200") {
                                    currentHBLInfo = JSON.parse(response.data.object);
                                    let newTableHBLInfo = [];
                                    let currentIndex = 0;
                                    this.tableHBLInfo.forEach((item,index)=>{
                                        if(item.bookingHeadId == currentHBLInfo.bookingHeadId){
                                            newTableHBLInfo.push(currentHBLInfo);
                                            currentIndex = index;
                                        }else{
                                            newTableHBLInfo.push(item);
                                        }
                                    });
                                    this.tableHBLInfo = newTableHBLInfo;
                                    if (this.tableHBLInfo.length > 0) {
                                        this.setTableCurrentRow(2, currentIndex);
                                    }
                                    this.calculatePartTotal();
                                } else {
                                    this.showMessage(false, this.responseCode, "error");
                                }
                            }).catch(error => {
                                //请求失败,查询按钮设置为未点击状态,允许再次请求
                                if (error.data) {
                                    this.tableHBLInfo = [];
                                    this.tableHBLPreContainerInfo = [];
                                    this.responseCode = error.data.backMessage;
                                    this.showMessage(false, this.responseCode, "error");
                                } else {
                                    this.showMessage(false, error, "error");
                                }
                            });
                        }else{
                            this.showMessage(false, this.$t('message.pleaseSelecte2Copy'),"warning");
                            return;
                        }
                    }
                }else{
                    this.showMessage(false, this.$t('message.noSelectedHBL'),"warning");
                }
            },


            /**
             * 航次分单信息查询
             */
            queryHBLByVoyageAction() {
                // 清空之前的航次分单数据
                this.popTableSearchHBLInfo = [];
                if (this.tableBillInfoSelection.length > 0) {
                    let spliteMBL = this.tableBillInfoSelection[0];

                    // 如果当前选中的提单已拆/并过单，则不允许继续拆单
                    if ((spliteMBL.spliteCombinType !== undefined && spliteMBL.spliteCombinType !== null && spliteMBL.spliteCombinType !== '') ||
                            (spliteMBL.mainDetailType !== undefined && spliteMBL.mainDetailType !== null && spliteMBL.mainDetailType !== '')) {
                        this.showMessage(false, "提单："+spliteMBL.blNo+" 已做过拆单操作，不能重复拆单", "error");
                        return;
                    }

                    //设置分单查询船名航次参数
                    this.HBLSearch.vesselCode = spliteMBL.vesselCode;
                    this.HBLSearch.voyageNo = spliteMBL.voyageNo;
                    this.HBLSearch.voyageLeg = spliteMBL.voyageLeg;
                    this.HBLSearch.pod = spliteMBL.pod;
                    this.HBLSearch.shipperCode = spliteMBL.shipperCode;
                    //打开查询弹框
                    this.HBLInfoDialogVisible = true;
                }
            },
            /**
             * 新增分单
             */
            newHBLAction() {
                if (this.tableBillInfo.length > 0 && this.tableBillInfoSelection.length > 0) {
                    let spliteMBL = this.tableBillInfoSelection[0];

                    // 如果当前选中的提单已拆/并过单，则不允许继续拆单
                    if ((spliteMBL.spliteCombinType !== undefined && spliteMBL.spliteCombinType !== null && spliteMBL.spliteCombinType !== '') ||
                        (spliteMBL.mainDetailType !== undefined && spliteMBL.mainDetailType !== null && spliteMBL.mainDetailType !== '')) {
                        this.showMessage(false, "提单："+spliteMBL.blNo+" 已做过拆单操作，不能重复拆单", "error");
                        return;
                    }

                    //调用后端保存API
                    this.axios({
                        method: 'post',
                        url: '/api/spliteCombine/getCopyOfMBLInfo',
                        data: {
                            bookingHeadId: this.tableBillInfoSelection[0].bookingHeadId
                        },
                        headers: {
                            'Accept-language': localStorage.getItem("locale"),
                            'Content-type': "application/json;charset=utf-8"
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            this.count++;
                            let newHBL = JSON.parse(response.data.object);
                            // 赋值分单临时id
                            newHBL.bookingHeadId = this.count + "1";
                            // 关联分单及下货纸信息
                            if(newHBL.bkPreContainers != null && newHBL.bkPreContainers.length > 0){
                                newHBL.bkPreContainers.forEach((item)=>{
                                    item.bookingHeadId = newHBL.bookingHeadId;
                                })
                            }
                            //分单新增到分单信息表格中
                            this.tableHBLInfo.push(newHBL);
                            //设置分单选中最后一行
                            this.setTableCurrentRow(2, this.tableHBLInfo.length - 1);
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                        }
                        //请求成功,查询按钮设置为未点击状态,允许再次请求
                        this.isClick = false;
                    }).catch(error => {
                        //请求失败,查询按钮设置为未点击状态,允许再次请求
                        this.isClick = false;
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                }
            },
            /**
             * 删除分单
             */
            deleteHBLAction() {
                if (this.tableHBLInfo.length > 0) {
                    // 校验是否有选中分单
                    if (this.tableHBLInfoSelection == null || this.tableHBLInfoSelection.length <= 0) {
                        this.$alert(this.$t('message.pleaseSelectHBL2Delete'), this.$t("common.tips"), {
                            confirmButtonText: this.$t("common.okButton")
                        });
                        return;
                    }

                    //是否删除勾选的分单
                    this.$confirm(this.$t('message.hblDeleteConfirm',{hbl:this.tableHBLInfoSelection[0].blNo}), this.$t("common.pleaseConfirm"), {
                        distinguishCancelAndClose: true,
                        confirmButtonText: this.$t("common.deleteButton"),
                        cancelButtonText: this.$t("common.cancelButton")
                    }).then(() => {
                        this.tableHBLInfo.splice(this.tableHBLInfoSelection[0].index, 1);
                    });
                }
            },
            /**
             * 删除分单选中的订舱预配箱信息
             */
            DeleteHBLPreContainerDeleteAction() {
                if (this.tableHBLPreContainerInfo.length > 0) {
                    // 校验是否有选中分单下货纸信息
                    if (this.tableHBLPreContainerInfoSelection == null || this.tableHBLPreContainerInfoSelection.length <= 0) {
                        this.$alert(this.$t('message.noSelectedHBLPreContainer2Delete'), this.$t("common.tips"), {
                            confirmButtonText: this.$t("common.okButton")
                        });
                        return;
                    }

                    //是否删除选中的分单订舱预配箱信息
                    this.$confirm(this.$t('message.hblPreContainerDeleteConfirm',
                            {containerType:this.tableHBLPreContainerInfoSelection[0].containerType}), this.$t("common.pleaseConfirm"), {
                        distinguishCancelAndClose: true,
                        confirmButtonText: this.$t("common.deleteButton"),
                        cancelButtonText: this.$t("common.cancelButton")
                    }).then(() => {
                        this.tableHBLPreContainerInfo.splice(this.tableHBLPreContainerInfoSelection[0].index, 1);
                    });
                }
            },
            /**
             * 保存分单
             */
            saveHBLAction() {
                //校验是否可分单
                if (!this.validateOnSaveBefore()) {
                    return;
                }

                //调用后端保存API
                this.axios({
                    method: 'post',
                    url: '/api/spliteCombine/saveSpliteAction',
                    data: {
                        vwSpliteCombinList: JSON.stringify(this.tableHBLInfo),
                        bookingHeadMBLId: this.tableBillInfoSelection[0].bookingHeadId
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale"),
                        'Content-type': "application/json;charset=utf-8"
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        // 清空主/分单表格当前选中行
                        this.tableBillInfoSelection = [];
                        this.tableHBLInfoSelection = [];
                        // 清空新增分单记录集合
                        this.addHBLBillInfoList = [];
                        //赋值主单数据
                        let billInfo = JSON.parse(response.data.object);

                        this.tableBillInfo = [billInfo];
                        if (this.tableBillInfo.length > 0) {
                            this.setTableCurrentRow(0, 0);
                        }
                        this.showMessage(false, this.$t('message.saveSucceed'), "success");
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    //请求成功,查询按钮设置为未点击状态,允许再次请求
                    this.isClick = false;
                }).catch(error => {
                    //请求失败,查询按钮设置为未点击状态,允许再次请求
                    this.isClick = false;
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            validateOnSaveBefore() {
                let count = this.tableHBLInfo.length;
                // 拆单时分单信息不能少于两条
                if (count < 2) {
                    this.$alert(this.$t('message.cannotLT2HBLS'), this.$t("common.tips"), {
                        confirmButtonText: this.$t("common.okButton")
                    });
                    return false;
                }
                // 判断分单提单号、订舱号不能相同
                let blNos = [];
                let bkNos = [];
                let quantityTotal = 0;
                let grossWeightTotal = 0;
                let cargoSizeTotal = 0;
                this.tableHBLInfo.forEach((item) => {
                    if (!blNos.includes(item.blNo)) {
                        blNos.push(item.blNo);
                    }
                    if (!bkNos.includes(item.bkNo)) {
                        bkNos.push(item.bkNo);
                    }
                    //统计件数
                    if (item.cargoQuantity !== "") {
                        quantityTotal = quantityTotal + parseFloat(item.cargoQuantity)
                    }
                    //统计毛重
                    if (item.cargoGrossWeight !== "") {
                        grossWeightTotal = grossWeightTotal + parseFloat(item.cargoGrossWeight)
                    }
                    //统计尺寸
                    if (item.cargoSize !== "") {
                        cargoSizeTotal = cargoSizeTotal + parseFloat(item.cargoSize)
                    }
                });
                if (blNos.length < count) {
                    this.$alert(this.$t('message.existsDuplicatedBlNo'), this.$t("common.tips"), {
                        confirmButtonText: this.$t("common.okButton")
                    });
                    return false;
                }
                if (bkNos.length < count) {
                    this.$alert(this.$t('message.existsDuplicatedBkNo'), this.$t("common.tips"), {
                        confirmButtonText: this.$t("common.okButton")
                    });
                    return false;
                }

                // 校验分单非空字段
                if (!this.validateIsNull()) {
                    return false;
                }

                // 校验分单下货纸信息是否录入
                this.tableHBLInfo.forEach((item) => {
                    if(item.bkPreContainers == null || item.bkPreContainers.length <= 0){
                        this.showMessage(false, this.$t('message.hblNoBkPreContainer',{hbl:item.blNo}), "error");
                        return false;
                    }
                });

                let billMaster = this.tableBillInfoSelection[0];
                // // 校验分单件毛体总和与主单件毛体是否一致
                // quantityTotal = this.toDecimal2(quantityTotal);
                // grossWeightTotal = this.toDecimal2(grossWeightTotal);
                // cargoSizeTotal = this.toDecimal2(cargoSizeTotal);
                // if (billMaster.cargoQuantity !== ""
                //     && parseFloat(billMaster.cargoQuantity) !== quantityTotal) {
                //     this.showMessage(false, this.$t('message.quantityInconsistent',
                //             {quantityTotal:quantityTotal,quantity:this.toDecimal2(billMaster.cargoQuantity)}), "error");
                //     return false;
                // }
                // if (billMaster.cargoGrossWeight !== ""
                //     && parseFloat(billMaster.cargoGrossWeight) !== grossWeightTotal) {
                //     this.showMessage(false, this.$t('message.weightInconsistent',
                //         {grossWeightTotal:grossWeightTotal,cargoGrossWeight:this.toDecimal2(billMaster.cargoGrossWeight)}), "error");
                //     return false;
                // }
                // if (billMaster.cargoSize !== ""
                //     && parseFloat(billMaster.cargoSize) !== cargoSizeTotal) {
                //     this.showMessage(false, this.$t('message.sizeInconsistent',
                //         {cargoSizeTotal:cargoSizeTotal,cargoSize:this.toDecimal2(billMaster.cargoSize)}), "error");
                //     return false;
                // }

                // 校验主、分单船名航次和POD是否一致
                try {
                    this.tableHBLInfo.forEach((item) => {
                        if (!this.validateValueIsSame(billMaster, item)) {
                            throw new Error("EndForEach");
                        }
                    })
                } catch (error) {
                    if (error.message === "EndForEach") {
                        return false;
                    } else {
                        this.showMessage(false, error, "error");
                    }
                }
                return true;
            },
            validateValueIsSame(vwSpliteCobin, vwSpliteCobinHBL) {
                // 判断主分单船名都为空时
                let returnValue = vwSpliteCobin.vesselCode === ""
                    && vwSpliteCobinHBL.vesselCode === "";

                // 判断主分单船名都不为空且值都相等时
                returnValue = returnValue ||
                    (vwSpliteCobin.vesselCode !== ""
                        && vwSpliteCobinHBL.vesselCode !== ""
                        && vwSpliteCobin.vesselCode == vwSpliteCobinHBL.vesselCode);

                // 判断主分单航次都为空时
                returnValue = (vwSpliteCobin.voyageNo === ""
                    && vwSpliteCobinHBL.voyageNo === "");

                // 判断主分单航次都不为空且值都相等时
                returnValue = returnValue
                    || (vwSpliteCobin.voyageNo !== ""
                        && vwSpliteCobinHBL.voyageNo !== ""
                        && vwSpliteCobin.voyageNo == vwSpliteCobinHBL.voyageNo);

                // 判断主分单POD都为空时
                returnValue = (vwSpliteCobin.pod === ""
                    && vwSpliteCobinHBL.pod === "");

                // 判断主分单POD都不为空且值都相等时
                returnValue = returnValue
                    || (vwSpliteCobin.pod !== ""
                        && vwSpliteCobinHBL.pod !== ""
                        && vwSpliteCobin.pod == vwSpliteCobinHBL.pod);

                // 判断主分单Shipper都为空时
                returnValue = (vwSpliteCobin.shipperCode === ""
                    && vwSpliteCobinHBL.shipperCode === "");

                // 判断主分单Shipper都不为空且值都相等时
                returnValue = returnValue
                    || (vwSpliteCobin.shipperCode !== ""
                        && vwSpliteCobinHBL.shipperCode !== ""
                        && vwSpliteCobin.shipperCode == vwSpliteCobinHBL.shipperCode);

                if (!returnValue) {
                    this.$alert(this.$t('message.noMatchCannotSplite'), this.$t("common.tips"), {
                        confirmButtonText: this.$t("common.okButton")
                    });
                    return false;
                }
                return returnValue;
            },
            /**
             * 校验舱单信息表格中当前选中的提单是否为拆单主单
             */
            validateIsSplitBill() {
                if (this.tableBillInfoSelection.length > 0) {
                    let vwSpliteCobin = this.tableBillInfoSelection[0];
                    let spliteCombinType = null;
                    let mainDetailType = 0;
                    if (vwSpliteCobin.spliteCombinType != null) {
                        spliteCombinType = vwSpliteCobin.spliteCombinType;
                    } else {
                        return false;
                    }
                    if (vwSpliteCobin.mainDetailType != null) {
                        mainDetailType = vwSpliteCobin.mainDetailType;
                    }
                    if (spliteCombinType == 0 && mainDetailType == 0) {
                        return true;
                    }
                    return false;
                } else {
                    return false;
                }
            },
            /**
             * 校验舱单信息表格中当前选中的提单是否上传了箱信息，有箱信息时不支持拆并单
             */
            validateHasContainers() {
                if (this.tableBillInfoSelection.length > 0) {
                    let vwSpliteCobin = this.tableBillInfoSelection[0];
                    if (vwSpliteCobin.bkContainers != null && vwSpliteCobin.bkContainers.length > 0) {
                        return true;
                    }
                    return false;
                } else {
                    return false;
                }
            },
            /**
             * 校验新增分单非空字段
             */
            validateIsNull() {
                let errorMsg = [];
                if (this.tableHBLInfo.length > 0) {
                    this.tableHBLInfo.forEach((item, index) => {
                        if (item.rowStatus === 4) {
                            // 提单号非空
                            if (item.blNo === "") {
                                errorMsg.push(this.$t('message.hblInfoNoBlNo',{index:(index+1)}));
                            }
                            // 订舱号非空
                            if (item.bkNo === "") {
                                errorMsg.push(this.$t('message.hblInfoNoBkNo',{index:(index+1)}));
                            }
                            // 唛头非空
                            if (item.cargoShippingMark === "") {
                                errorMsg.push(this.$t('message.hblInfoNoCargoShippingMark',{index:(index+1)}));
                            }
                            // 件数非空
                            if (item.cargoQuantity === "" || item.cargoQuantity == 0) {
                                errorMsg.push(this.$t('message.hblInfoNoCargoQuantity',{index:(index+1)}));
                            }
                            // 毛重非空
                            if (item.cargoGrossWeight === "" || item.cargoGrossWeight == 0) {
                                errorMsg.push(this.$t('message.hblInfoNoCargoGrossWeight',{index:(index+1)}));
                            }
                            // 尺寸非空
                            if (item.cargoSize === "" || item.cargoSize == 0) {
                                errorMsg.push(this.$t('message.hblInfoNoCargoSize',{index:(index+1)}));
                            }
                        }
                    });
                    if (errorMsg.length > 0) {
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: errorMsg.join(' <br/><br/> '),
                            type: 'error'
                        });
                        return false;
                    }
                }
                return true;
            },
            /**
             * 取消拆单
             */
            cancelSpliteAction() {
                if (this.tableBillInfoSelection.length > 0) {
                    //获取选中的拆单主单
                    let spliteMBL = this.tableBillInfoSelection[0];

                    let cancelBlNos = "";
                    this.tableHBLInfo.forEach((item) => {
                        if (item.dataSource == 4) {
                            cancelBlNos = cancelBlNos + (cancelBlNos.length > 0 ? "," : "") + item.blNo;
                        }
                    });
                    if (cancelBlNos.length > 0) {
                        //是否删除分单
                        this.$confirm(this.$t('message.cancelSpliteNote',{hbls:cancelBlNos}), this.$t("common.pleaseConfirm"), {
                            distinguishCancelAndClose: true,
                            confirmButtonText: "删除",
                            cancelButtonText: "保留"
                        }).then(() => {
                            //调用后端拆单取消API
                            this.axios({
                                method: 'post',
                                url: '/api/spliteCombine/cancelSpliteAction',
                                data: {
                                    bookingHeadId: spliteMBL.bookingHeadId,
                                    isDeleteHBL: true
                                },
                                headers: {
                                    'Accept-language': localStorage.getItem("locale")
                                }
                            }).then(response => {
                                this.responseCode = response.data.backMessage;
                                if (response.data.backCode === "200") {
                                    this.voyageSpliteSearchAction();
                                } else {
                                    this.showMessage(false, this.responseCode, "error");
                                }
                                //请求成功,查询按钮设置为未点击状态,允许再次请求
                                this.isClick = false;
                            }).catch(error => {
                                //请求失败,查询按钮设置为未点击状态,允许再次请求
                                this.isClick = false;
                                if (error.data) {
                                    this.responseCode = error.data.backMessage;
                                    this.showMessage(false, this.responseCode, "error");
                                } else {
                                    this.showMessage(false, error, "error");
                                }
                            });
                        }).catch(action => {
                            //保留
                            if (action === 'cancel') {
                                //调用后端拆单取消API
                                this.axios({
                                    method: 'post',
                                    url: '/api/spliteCombine/cancelSpliteAction',
                                    data: {
                                        bookingHeadId: spliteMBL.bookingHeadId,
                                        isDeleteHBL: false
                                    },
                                    headers: {
                                        'Accept-language': localStorage.getItem("locale")
                                    }
                                }).then(response => {
                                    this.responseCode = response.data.backMessage;
                                    if (response.data.backCode === "200") {
                                        this.voyageSpliteSearchAction();
                                    } else {
                                        this.showMessage(false, this.responseCode, "error");
                                    }
                                    //请求成功,查询按钮设置为未点击状态,允许再次请求
                                    this.isClick = false;
                                }).catch(error => {
                                    //请求失败,查询按钮设置为未点击状态,允许再次请求
                                    this.isClick = false;
                                    if (error.data) {
                                        this.responseCode = error.data.backMessage;
                                        this.showMessage(false, this.responseCode, "error");
                                    } else {
                                        this.showMessage(false, error, "error");
                                    }
                                });
                                return;
                            }
                            if (action === 'cancel') {
                                return;
                            }
                        })
                    }
                }
            },

            popHBLResetClick() {
                this.HBLSearch.blNo = "";
            },
            popHBLSearchClick() {
                if (this.tableBillInfoSelection.length <= 0) {
                    return;
                }

                if (this.isClick) {
                    return;
                }
                this.isClick = true;

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),             // 加载动画的文字
                    spinner: 'el-icon-loading',                     // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                    target: document.querySelector(".popTableSearchHBLInfo")   // 设置加载动画区域
                });
                let that = this;

                // 获取已经添加到分单信息表格中的分单ID，在查询分单时需排除，避免重复添加
                let bookingHeadIds = this.tableBillInfoSelection[0].bookingHeadId;
                this.tableHBLInfo.forEach((bill) => {
                    if (bookingHeadIds.length > 0) {
                        bookingHeadIds = bookingHeadIds + ',' + bill.bookingHeadId;
                    } else {
                        bookingHeadIds = bookingHeadIds + bill.bookingHeadId;
                    }
                });

                //调用后端分单查询API
                this.axios({
                    method: 'post',
                    url: '/api/spliteCombine/getAllSpliteBillList',
                    data: {
                        vesselCode: this.HBLSearch.vesselCode,
                        voyageNo: this.HBLSearch.voyageNo,
                        voyageLeg: this.HBLSearch.voyageLeg,
                        blNo: this.HBLSearch.blNo,
                        shipperCode: this.HBLSearch.shipperCode,
                        pod: this.HBLSearch.pod,
                        bookingHeadId: bookingHeadIds
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        //清空分单批量选中记录
                        this.popTableHBLInfoChecked = [];
                        //赋值查询到的分单数据到表格中
                        let voyageHBLInfo = JSON.parse(response.data.object);
                        this.popTableSearchHBLInfo = voyageHBLInfo;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    //请求成功,查询按钮设置为未点击状态,允许再次请求
                    this.isClick = false;
                    that.loadingtuo.close();
                }).catch(error => {
                    //请求失败,查询按钮设置为未点击状态,允许再次请求
                    this.isClick = false;
                    that.loadingtuo.close();
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            popAddHBLClick() {
                if (this.popTableHBLInfoChecked != null && this.popTableHBLInfoChecked.length > 0) {
                    //获取批量勾选的分单记录，追加选中分单到分单信息表格中
                    this.popTableHBLInfoChecked.forEach((billNew) => {
                        this.tableHBLInfo.push(billNew);
                        //记录新增但还未保存的分单信息
                        this.addHBLBillInfoList.push(billNew);
                    });
                    //默认选中最后一行分单
                    if (this.tableHBLInfo.length > 0) {
                        this.setTableCurrentRow(2, this.tableHBLInfo.length - 1);
                    }
                    //清空分担查询弹框中选中记录集合
                    this.popTableHBLInfoChecked = [];
                    this.HBLInfoDialogVisible = false;
                }
            },
            popCancelClick() {
                //清空分单查询弹框中选中记录集合
                this.popTableHBLInfoChecked = [];
                this.HBLInfoDialogVisible = false;
            },

            /**
             * 船名航次VVL弹框 船名/搜索/关闭/确定 按钮点击
             */
            showVesselList() {//船名输入框点击
                this.boatListShow = true;
                this.axios({
                    method: 'get',
                    url: '/api/codedict/getVesselList',
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.boatList = response.data.object;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            closePopoverView() {//关闭按钮点击
                this.$refs.popover.showPopper = false;
            },
            vvlSearch() {//船名航次航段弹框 搜索按钮点击
                if (this.isVVLSearchClick) {
                    return;
                }
                this.isVVLSearchClick = true;
                this.axios({
                    method: 'post',
                    url: '/api/voyagePlan/getVVLEntity',
                    data: {
                        voyageNo: this.search.voyageNo,
                        voyageLeg: this.search.voyageLeg,
                        vesselName: this.search.vesselName,
                        vesselCode: this.search.vesselCode,
                        pageNum: this.popPageNum,
                        pageSize: this.popPageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.popData = response.data.object.list;
                        this.popTotal = response.data.object.total;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    this.isVVLSearchClick = false;
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    this.isVVLSearchClick = false;
                });
                //每次查询结束清空popVVLTableSelection
                this.popVVLTableSelection = [];
            },
            popConfirm() {//确认按钮点击,赋值选中记录的船名和航次到VVL查询输入框中
                if (this.popVVLTableSelection.length !== 0) {//获取弹框中最后选中的记录
                    this.popRowDblclick(this.popVVLTableSelection[0]);
                }
                this.$refs.popover.showPopper = false;
            },

            /************************************ 分页条 ************************************
             * VVL船名航次弹框数据分页条
             */
            popHandleDemand() {
                this.vvlSearch();
            },
            popHandleSizeChange(val) {
                this.popPageSize = val;
                this.popHandleDemand();
                this.$emit("backTop");
            },
            popHandleCurrentChange(val) {
                this.popPageNum = val;
                this.popHandleDemand();
                this.$emit("backTop");
            },

            /************************************ 行记录点击事件 ************************************
             * 船名航次VVL弹框行记录点击事件:
             *  某行被双击时,自动关闭弹框,获取该行船名航次数据,赋值订舱查询页船名航次输入框
             */
            popRowDblclick(row) {
                this.search.vesselCode = row.vesselCode;
                this.search.voyageNo = row.voyageNo;
                this.search.voyageLeg = row.voyageLeg;
                this.$refs.popover.showPopper = false;
            },
            popRowClick(row) {
                this.popVVLTableSelection = [row];
            },

            /************************************ 基础数据下拉框赋值 ************************************/
            /**
             * 货类
             */
            cargoTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getCargoTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.cargoTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 箱型
             */
            containerTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getContainerTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.containerTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },

            /************************************ 页面初始化 ************************************
             * 初始化基础数据
             */
            initCombos() {

            },

            /************************************ 接口返回数据国际化显示 *************************************/
            getspliteCombinDisplayValue(type) {
                let spliteCombinDesc = type;
                try {
                    if (type !== "") {
                        this.spliteCombinDescOptions.forEach((item) => {
                            if (item.codeValue === type) {
                                spliteCombinDesc = localStorage.getItem('locale') == 'en' ? item.displayValue : item.displayValueCn;
                                throw new Error("EndForEach");
                            }
                        })
                    }
                } catch (error) {
                    if (error.message === "EndForEach") {
                        return spliteCombinDesc;
                    } else {
                        this.showMessage(false, error, "error");
                    }
                }
            },
            getCargoTypeName(cargoTypeCode) {
                let cargoTypeName = cargoTypeCode;
                try {
                    if (cargoTypeCode !== "") {
                        if (this.cargoTypeOptions.length <= 0) {
                            this.cargoTypeFocus();
                        }
                        this.cargoTypeOptions.forEach((item) => {
                            if (item.codeValue === cargoTypeCode) {
                                cargoTypeName = item.displayValueCn;
                                throw new Error("EndForEach");
                            }
                        })
                    }
                } catch (error) {
                    if (error.message === "EndForEach") {
                        return cargoTypeName;
                    } else {
                        this.showMessage(false, error, "error");
                    }
                }
            },
        },
        mounted() {
        },
        created() {
            this.initCombos();
            this.$parent.updateHeaderAside();
        },
        activated() {

        }
    };
</script>
<style lang="scss" scoped>
    @import "../../assets/scss/base.scss";
    @import "../../assets/scss/public.scss";

    .jdt_nr {
        width: 50%;
        margin: 0 auto;
        z-index: 10001;
        top: 50%;
        margin-top: -31px;
        text-align: center;
        position: absolute;
        margin-left: 25%
    }

    .inputName {
        flex: 1;
        margin: 0 5px;
    }

    .topMargin {
        margin-top: 20px;
    }

    .searchBtn {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        margin: 0 5px;
    }

    .voyageIcon {
        margin-left: 10px;
        margin-top: 5px;
        width: 30px;
        height: 30px;
        border: 1px solid #0091ff;
        border-radius: 4px;
    }

    .noData {
        height: 100%;
        margin: 15px 0;
        background-color: #ffffff;
    }

    .searchList {
        margin: 15px 0;
    }

    /deep/ .el-input-group__prepend {
        background-color: #d9e3f0;
    }

    .popoverView {
        padding: 5px;
        background-color: #ffffff;
    }

    .popoverInner {
        margin: 5px;
        margin-top: 0;
    }

    .flex1 {
        flex: 1;
    }

    .boatBox {
        position: relative;

        .boatBox-list-box {
            min-width: 280px;
            position: absolute;
            left: 51px;
            top: 30px;
            background: $colorA;
            padding: 5px 10px;
            z-index: 100;
            border: 1px solid $colorE;
            font-size: $fontC;
            font-weight: 600;

            .boatBox-top {
                width: 100%;
                height: 20px;
                line-height: 20px;
                background: $colorB;
            }

            .left {
                width: 30%;
                margin-right: 4%;
            }

            .right {
                width: 66%;
            }

            ul {
                padding: 0;
                margin: 0;

                li {
                    border-bottom: 1px solid #e7f0fc;
                    padding: 4px 2px;
                }

                li:last-of-type {
                    border: none;
                }

                li:hover {
                    background: rgb(224, 240, 245);
                }
            }
        }
    }

    .cardTitle {
        margin-bottom: 10px;
        margin-top: 12px;

        span {
            font-size: $fontE;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .pop_show_table {
        position: relative;
        width: 100%;
        height: 250px;
        overflow: auto;
    }

    .show_table {
        position: relative;
        width: 100%;
        height: 250px;
        overflow: auto;
    }

    /*.toUpperCase ::v-deep .el-input__inner {*/
    /*    text-transform: uppercase !important;*/
    /*}*/
</style>